module.exports = __webpack_public_path__ + "img/banner_descuento.38256d05.jpg";